<template>
  <div :class="$style.container" id="loading" v-loading.fullscreen.lock.body="loading"
    :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-container>
      <div style="width:360px;" id="jurisdictionActive">
        <div :class="$style.left" style="height: 100%; display: flex; flex-direction: column">
          <el-row>

            <el-col>
              <div style="padding-top: 8px; font-size: 20px; margin-bottom: 30px">
                辖区管理<el-switch style="float: right;" v-model="territoryShowStatus" inactive-text="显示无效辖区"
                  @change="handleActive">
                </el-switch>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-col :span="10" style="border: 1px solid transparent">
              <span class="el-dropdown-link" style="color: #ff9901">
                <!--                                    2019年11月<i class="el-icon-caret-bottom el-icon--right"></i>-->
                <el-date-picker style="width: 120px; margin-top: -3px" value-format="yyyy-MM"
                  prefix-icon="el-icon-caret-bottom el-icon--right" v-model="valueDate" type="month" placeholder="选择月">
                </el-date-picker>
              </span>
            </el-col>
            <el-col :span="save_onoff ? 7 : 14" style="border: 1px solid transparent">
              <div align="right">
                <el-button @click="daochu" type="danger" style="
                    background: #4a90e2;
                    border: 1px solid transparent;
                    float: right;
                    margin-right: 0px;
                    width: 100px;
                  " icon="el-icon-download" size="small">
                  导入导出
                </el-button>
              </div>
            </el-col>
            <el-col :span="save_onoff ? 7 : 0" style="border: 1px solid transparent">
              <div align="right">
                <el-button v-if="save_onoff" style="
                    float: right;
                    width: 100px;
                    border: 1px solid transparent;
                  " :disabled="saveOff" type="success" @click="addJurisdiction()" icon="el-icon-plus" size="small">
                  新增辖区
                </el-button>
              </div>
            </el-col>
          </el-row>
          <!--                    <el-row style="margin-top: 20px">-->
          <!--                        <el-col :span="24">-->
          <!--                            <el-button class="el-icon-arrow-left"-->
          <!--                                       style="margin: 0;border-radius:0;width: 59px;">-->
          <!--                            </el-button><el-date-picker-->
          <!--                                    prefix-icon=" "-->
          <!--                                    clear-icon=""-->
          <!--                                    id="inputData"-->
          <!--                                    style="margin: 0;width: 240px;"-->
          <!--                                    v-model="dataTime"-->
          <!--                                    type="month"-->
          <!--                                >-->
          <!--                            </el-date-picker><el-button class="el-icon-arrow-right"-->
          <!--                                                        style="border-radius:0;width:60px;">-->
          <!--                            </el-button>-->
          <!--                        </el-col>-->

          <!--                    </el-row>-->
          <el-row id="el-rowInput" style="margin-top: -5px">
            <el-col>
              <el-autocomplete style="text-align: center" id="inputSeach" v-model="input" placeholder="请输入辖区名字进行快速检索"
                :fetch-suggestions="search" @select="handleSelect" :class="$style.search">
                <span slot-scope="{ item }">
                  <span style="margin-left: 21px; font-size: 14px; color: #555555">{{ item.territory_name }}</span>
                </span>
              </el-autocomplete>
            </el-col>
          </el-row>
          <div ref="scrollbar" id="treeDiv" style="
              border: 1px solid #dedede;
              height: 90%;
              border-top: none;
              flex-grow: 1;
              overflow: auto;
            ">
            <!--  lazy
                :load="loadNode" -->
            <el-tree ref="menusTreeAc" :data="folderArry" @node-click="handleNodeClick" :props="defaultProps" accordion
              :default-expanded-keys="[default_ID]" node-key="territory_id" :highlight-current="true"
              :expand-on-click-node="false" :current-node-key="default_ID">
              <div style="font-size: 16px; display: flex;align-items:center" slot-scope="{ node }">
                <!-- 图标 -->
                <div style="
                    flex-shrink: 0;
                    width: 20px;
                    height: 20px;
                    margin: 0 10px 0 10px;
                  ">
                  <img style="line-height: 20px" :src="node.data.territory_type == 'ENDPOINT' ? icon[1] : icon[0]"
                    alt=" " />
                </div>
                <div style="flex-grow:1;line-height: 20px;word-break: break-all;">
                  <!-- 标题 -->
                  <span v-if="node.data.territory_type != 'ENDPOINT' && node.data.status=='ACTIVE'">{{
                    node.data.territory_name }}</span>
                  <span v-else-if="node.data.territory_type != 'ENDPOINT' && node.data.status=='INACTIVE'"
                    style="text-decoration:line-through">{{ node.data.territory_name }}</span>
                  <!-- 编号 -->
                  <span v-else-if="node.data.territory_type == 'ENDPOINT' && node.data.status=='ACTIVE'">{{
                    node.data.territory_name }}&nbsp;&nbsp;&nbsp;{{
                    !node.data.territory_code || '(' + node.data.territory_code + ')'
                    }}
                  </span>
                  <span v-else-if="node.data.territory_type == 'ENDPOINT' && node.data.status=='INACTIVE'"
                    style="text-decoration:line-through">{{ node.data.territory_name }}&nbsp;&nbsp;&nbsp;{{
                    !node.data.territory_code || '(' + node.data.territory_code + ')'
                    }}
                  </span>
                </div>
              </div>
            </el-tree>
          </div>
        </div>
      </div>
      <div style="height: 2%"></div>
      <el-main style="position: relative; padding-right: 0">
        <div style="
            position: absolute;
            left: 50%;
            margin-left: -334px;
            top: 0;
            z-index: 100;
          ">
          <!--                                    <el-radio-group v-model="isCollapse" @change="clickTab" >-->
          <!--                                        <el-radio-button label="true">尚未生效的辖区</el-radio-button>-->
          <!--                                        <el-radio-button label="false">已生效的辖区管理</el-radio-button>-->
          <!--                                    </el-radio-group>-->
          <el-button-group>
            <el-button @click="clickTab('inactive')" style="width: 154px">待生效的辖区数据</el-button>
            <el-button @click="clickTab('active')" style="
                color: #409eff;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
              ">已生效的辖区管理
            </el-button>
          </el-button-group>
        </div>
        <div :class="$style.right" style="">
          <div :class="$style.header">
            <el-row style="margin-bottom: 4px">
              <el-col>
                <div style="margin-left: 28%">
                  <!--                                    <el-radio-group v-model="isCollapse" @change="clickTab" style="margin-bottom: 30px;" >-->
                  <!--                                        <el-radio-button label="true">尚未生效的辖区</el-radio-button>-->
                  <!--                                        <el-radio-button label="false">已生效的辖区管理</el-radio-button>-->
                  <!--                                    </el-radio-group>-->
                  <!--                                    <el-button-group>-->
                  <!--                                        <el-button @click="clickTab('inactive')">尚未生效的辖区</el-button>-->
                  <!--                                        <el-button-->
                  <!--                                                @click="clickTab('active')"-->
                  <!--                                                style="color: #409EFF;border-color: #c6e2ff;-->
                  <!--                                                background-color: #ecf5ff;">已生效的辖区管理</el-button>-->
                  <!--                                    </el-button-group>-->
                </div>
                <!--                                <a id="effect" @click.prevent="effectNo()" :class="{styleA : styleA}"-->
                <!--                                   href="">尚未生效的辖区</a>-->
                <!--                                <a id="effect2" @click.prevent="effectOff()" :class="{styleA : styleA2}"-->
                <!--                                   href="">已生效的辖区管理-->
                <!--                                </a>-->
                <!--                                <el-button autofocus="false" @click="effectNo" style="margin-right: 0;">尚未生效的辖区-->
                <!--                                </el-button><el-button-->
                <!--                                    @click="effectOff"-->
                <!--                                    style="margin-left: 0">已生效的辖区管理</el-button>-->
              </el-col>
            </el-row>
            <el-row style="height: 56px; margin-top: 30px; width: 100%">
              <el-col :span="14" style="
                  border: 1px solid transparent;
                  height: 100%;
                  position: relative;
                  margin-top: 3px;
                ">
                <div v-if="territory_region === '地区'" style="
                    padding-top: 8px;
                    height: 100%;
                    float: left;
                    width: 100%;
                  ">
                  <span style="color: #3b99f7; line-height: 56px">{{ territory_name }}</span>
                  <p v-if="territory_level_name != ''" id="regionP" style="">
                    {{ territory_level_name }}
                  </p>
                  <span v-if="salList == 0" style="
                      display: inline-block;
                      padding: 4px 8px;
                      border-radius: 2px;
                      color: white;
                      font-size: 12px;
                      background: #bbbbbb;
                    ">无人管理</span>
                </div>
                <div v-if="territory_region === '终端'" style="padding-top: 8px; height: 100%; float: left">
                  <span style="color: #3b99f7; line-height: 56px">{{ territory_name }} ({{ territory_code }})</span>
                </div>
                <div v-if="territory_region === '终端'" style="float: left; height: 100%; color: cornflowerblue">
                  <p v-if="owner_name != ''" style="
                      font-size: 12px;
                      color: #bbbbbb;
                      margin-top: 25px;
                      margin-left: 10px;
                    ">
                    <span style="
                        display: inline-block;
                        padding: 4px 8px;
                        border-radius: 2px;
                        color: white;
                        background: #ff9901;
                      ">{{ owner_name }}</span>&nbsp;
                    <span>职务:&nbsp;{{ owner_title }}</span>
                    <span></span>
                  </p>
                  <p v-if="owner_name == ''" style="
                      margin-left: 10px;
                      font-size: 12px;
                      margin-top: 28px;
                      color: #bbbbbb;
                    ">
                    <span style="
                        display: inline-block;
                        padding: 4px 8px;
                        border-radius: 2px;
                        color: white;
                        background: #bbbbbb;
                      ">无人负责</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="10" style="
                  border: 1px solid transparent;
                  height: 100%;
                  position: relative;
                  margin-top: 3px;
                ">
                <el-button v-if="save_onoff" style="
                    float: right;
                    margin-top: 18px;
                    margin-right: -1px;
                    background: #ff9901;
                    color: white;
                    border: 1px solid #ff9901;
                  " size="small" @click.stop="upDataJurisdiction()">
                  编辑
                </el-button>
                <el-button v-else style="
                    float: right;
                    margin-top: 18px;
                    margin-right: -1px;
                    background: #ff9901;
                    color: white;
                    border: 1px solid #ff9901;
                  " size="small" @click.stop="upDataJurisdiction()">
                  详情
                </el-button>
                <!-- prob -->
                <div style="float: right; margin-top: 24px; font-size: 14px">
                  终端辖区
                  <el-switch :disabled="true" style="margin-right: 20px" v-model="terminal" active-color="#13ce66">
                  </el-switch>
                </div>
              </el-col>
            </el-row>
          </div>

          <!--<div :class="$style.header">-->
          <!--<span>文件夹</span>-->
          <!--<span>{{companyName}}</span>-->

          <!--</div>-->

          <!--                    <div align="right">-->
          <!--                    <el-button type="primary" icon="el-icon-edit">编辑</el-button>-->
          <!--                    </div>-->

          <div :class="$style.body">
            <!--<router-view></router-view>-->
            <!--<el-scrollbar :class="$style.scrollbar" >-->
            <router-view :key="upKey"></router-view>
            <!--</el-scrollbar>-->
          </div>
        </div>
      </el-main>
    </el-container>

    <!--新增辖区-->
    <el-dialog title="" :visible.sync="modeldialog" :show-close="false" id="add_jurisdictionActive">
      <div slot="title" class="dialog-footer" style="
          display: flex;
          justify-content: space-between;
          border-bottom: 2px dashed #e7eaec;
          padding: 10px 0px;
        ">
        <span style="color: #3998f7; font-size: 22px; padding-top: 5px">新增辖区</span>
        <span>
          <el-button @click="inputSaveJurisdiction()" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="closeAddDialog" size="small">取消</el-button>
        </span>
      </div>
      <el-form class="formSave" ref="addJurisdictionFrom" :model="addJurisdictionFrom" style="width: 80%; margin: auto"
        label-position="left" hide-required-asterisk>
        <el-form-item label="上级辖区" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7">
              {{ addJurisdictionFrom.topJurisdiction_name }}
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="辖区名称" label-width="100px" class="jurisdiction_star" prop="jurisdiction_name"
          :rules="[{ required: true, message: '辖区名称不能为空' }]">
          <el-input v-model="addJurisdictionFrom.jurisdiction_name"></el-input>
        </el-form-item>
        <el-form-item label="辖区编码" label-width="100px" class="jurisdiction_star" prop="jurisdiction_code"
          :rules="[{ required: true, message: '辖区编码不能为空' }]">
          <el-input v-model="addJurisdictionFrom.jurisdiction_code"></el-input>
        </el-form-item>
        <el-form-item label="辖区等级" label-width="100px">
          <el-select v-model="addJurisdictionFrom.jurisdiction_level" placeholder="" style="width: 100%"
            :disabled="addJurisdictionFrom.terminalJurisdiction">
            <el-option v-for="(item, index) in jurisdictionLevel" :key="index" :label="item.value1" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" label-width="100px">
          <el-input v-model="addJurisdictionFrom.commit"></el-input>
        </el-form-item>
        <el-form-item label="终端辖区" label-width="100px">
          <el-switch v-model="addJurisdictionFrom.terminalJurisdiction" active-color="#13ce66"> </el-switch>
        </el-form-item>
        <el-form-item v-if="addJurisdictionFrom.terminalJurisdiction" label="所有人" label-width="100px">
          <el-cascader style="width: 100%" v-model="addJurisdictionFrom.selectPeople" @change="changeEveryOne"
            :show-all-levels="false" :filterable="true" :options="JurisdictionUser" :props="cascader_props" clearable>
          </el-cascader>
          <!--                    <el-select v-model="addJurisdictionFrom.selectPeople"-->
          <!--                               style="width: 100%;"-->
          <!--                               placeholder="请选择" @change="changeEveryOne">-->
          <!--                        <el-option-->
          <!--                                v-for="item,index in JurisdictionUser"-->
          <!--                                :key="index"-->
          <!--                                :label="item.alias"-->
          <!--                                :value="item.user_id">-->
          <!--                        </el-option>-->
          <!--                    </el-select>-->
        </el-form-item>
        <el-form-item v-if="addJurisdictionFrom.terminalJurisdiction && ismanager" label="覆盖城市" label-width="100px">
          <el-cascader style="width: 100%" v-model="addJurisdictionFrom.city" @change="changeEveryOne"
            :options="city_array" :filterable="true" :props="city_props" clearable></el-cascader>
        </el-form-item>

        <el-form-item v-if="addJurisdictionFrom.terminalJurisdiction && ismanager" label="推广产品" label-width="100px">
          <LazySelect v-model="addJurisdictionFrom.product" placeholder="请选择" remote reserve-keyword
            :remote-method="remoteMethodAdd" @scrollEnd="scrollEndAdd" @visibleChange="lazyVisibleChangeAdd"
            :loading="remoteLoadingAdd" :finishOptions="finishOptionsAdd" :loadingOptions="loadingOptionsAdd"
            :valueKey="{ key: 'value', label: 'product_name', value: 'product_id' }" :options="productList" filterable
            multiple></LazySelect>
          <!--          <el-select-->
          <!--            v-model="addJurisdictionFrom.product"-->
          <!--            value-key="product_id"-->
          <!--            multiple-->
          <!--            placeholder="请选择"-->
          <!--          >-->
          <!--            <el-option-->
          <!--              v-for="item in productList"-->
          <!--              :key="item"-->
          <!--              :label="item.product_name"-->
          <!--              :value="item"-->
          <!--            >-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="modelImport" :show-close="false" width="60%">
      <div slot="title" class="dialog-footer" style="
          display: flex;
          justify-content: space-between;
          border-bottom: 2px dashed #e7eaec;
          padding: 20px 0px;
        ">
        <span style="color: #3998f7; font-size: 22px">数据导入与导出</span>
        <span>
          <el-button @click="" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="modelImport = false" size="small">取消</el-button>
        </span>
      </div>
      <div style="padding: 20px 60px">
        <el-row style="height: 30px">
          <el-col :span="3" style="line-height: 30px; font-weight: bold">下载数据</el-col>
          <el-col :span="3" style="line-height: 30px">
            <el-button type="primary" size="small"> 下载 </el-button>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row style="height: 30px; margin-top: 50px">
          <el-col :span="3" style="line-height: 30px; font-weight: bold">辖区模板</el-col>
          <el-col :span="3" style="line-height: 30px">
            <el-button type="primary" size="small"> 下载 </el-button>
          </el-col>
          <el-col :span="10"></el-col>
        </el-row>
        <el-row style="height: 30px; margin-top: 20px">
          <el-col :span="3" style="line-height: 30px; font-weight: bold">上传数据</el-col>
          <el-col :span="13" style="line-height: 30px" id="elColImport">
            <el-input id="elInputImport"></el-input>
          </el-col>
          <el-col :span="6" style="margin-left: 10px">
            <el-button type="success" size="small" style="margin: 0; height: 30px">选择文件</el-button>
            <el-button type="warning" size="small" style="margin: 0; height: 30px">导入数据</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="modeljurisdiction" :show-close="false" width="60%">
      <div slot="title" class="dialog-footer" style="
          display: flex;
          justify-content: space-between;
          border-bottom: 2px dashed #e7eaec;
          padding: 20px 0px;
        ">
        <span style="color: #3998f7; font-size: 22px">辖区数据生效</span>
        <span>
          <el-button type="danger" @click="modeljurisdiction = false" size="small">关闭</el-button>
        </span>
      </div>
      <div style="padding: 60px 60px">
        <el-row style="text-align: center">
          <el-col :span="12">[本月] {{ date }}
            <el-button style="
                margin-left: 10px;
                background: #ff9901;
                border: 1px solid #ff9901;
                color: white;
              ">立即生效
            </el-button>
          </el-col>
          <el-col :span="12">[下月] 2019年11月数据
            <el-button style="
                margin-left: 10px;
                background: #ff9901;
                border: 1px solid #ff9901;
                color: white;
              ">立即生效
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="modeljurisdictionExport" :show-close="false" width="700px">
      <div slot="title" class="dialog-footer" style="
          display: flex;
          justify-content: space-between;
          border-bottom: 2px dashed #e7eaec;
          padding: 20px 0px;
        ">
        <span style="color: #3998f7; font-size: 22px">数据导入与导出</span>
        <span>
          <el-button type="danger" @click="closeModal" size="small">关闭</el-button>
        </span>
      </div>
      <div>
        <el-row style="height: 30px">
          <el-col :span="5" style="line-height: 30px; font-weight: bold">下载数据[医务]</el-col>
          <el-col :span="3" style="line-height: 30px">
            <el-button type="primary" size="small" @click="xiazai">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px">
            <i class="el-icon-document" />
            医疗机构-辖区数据({{ valueDate }}).xls
          </el-col>
        </el-row>
        <el-row style="height: 30px; margin-top: 10px" v-if="save_onoff">
          <el-col :span="5" style="line-height: 30px; font-weight: bold">辖区模板[医务]</el-col>
          <el-col :span="3" style="line-height: 30px">
            <a style="text-decoration: none; color: #ffff" class="el-button el-button--primary el-button--small"
              href="../../../static/医疗机构-目标客户数据导入模板.xlsx" download="医疗机构-目标客户数据导入模板.xlsx">下载</a>
          </el-col>
          <el-col :span="10" style="padding-top: 8px">
            <i class="el-icon-document" />
            医疗机构-目标客户数导入据模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px" v-if="save_onoff">
          <el-col :span="4" style="line-height: 30px; font-weight: bold">
            上传数据[医务]
          </el-col>
          <el-col :span="10" style="margin-top: 3px; margin-left: 28px">
            <div style="border: 1px solid #ededed; height: 30px">
              <span style="position: relative; top: 8px; left: 5px">{{ file }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px; margin-left: 20px">
            <el-upload class="upload-demo" ref="upload" accept=".xlsx,.xls" action="" :file-list="fileList"
              :show-file-list="false" :on-change="handleChange" :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small" style="
                  background-color: #7ed321;
                  border: 1px solid #7ed321;
                  color: white;
                ">选择文件
              </el-button>
              <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>

        <el-row style="height: 30px; margin-top: 30px">
          <el-col :span="5" style="line-height: 30px; font-weight: bold">下载数据[零售]</el-col>
          <el-col :span="3" style="line-height: 30px">
            <el-button type="primary" size="small" @click="xiazai2">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px">
            <i class="el-icon-document" />
            零售终端-辖区数据({{ valueDate }}).xls
          </el-col>
        </el-row>
        <el-row style="height: 30px; margin-top: 10px" v-if="save_onoff">
          <el-col :span="5" style="line-height: 30px; font-weight: bold">辖区模板[零售]</el-col>
          <el-col :span="3" style="line-height: 30px">
            <a style="text-decoration: none; color: #ffff" class="el-button el-button--primary el-button--small"
              href="../../../static/零售终端-目标客户数据导入模板.xlsx" download="零售终端-目标客户数据导入模板.xlsx">下载</a>
          </el-col>
          <el-col :span="10" style="padding-top: 8px">
            <i class="el-icon-document" />
            零售终端-目标客户数导入据模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px" v-if="save_onoff">
          <el-col :span="4" style="line-height: 30px; font-weight: bold">
            上传数据[零售]
          </el-col>
          <el-col :span="10" style="margin-top: 3px; margin-left: 28px">
            <div style="border: 1px solid #ededed; height: 30px">
              <span style="position: relative; top: 8px; left: 5px">{{ file2 }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px; margin-left: 20px">
            <el-upload class="upload-demo" ref="upload2" accept=".xlsx,.xls" action="" :file-list="fileList2"
              :show-file-list="false" :on-change="handleChange2" :on-success="handleSuccess2" :limit="1"
              :auto-upload="false">
              <el-button slot="trigger" size="small" style="
                  background-color: #7ed321;
                  border: 1px solid #7ed321;
                  color: white;
                ">选择文件
              </el-button>
              <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick2">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>

        <el-row style="height: 30px; margin-top: 30px">
          <el-col :span="5" style="line-height: 30px; font-weight: bold">下载数据[分销]</el-col>
          <el-col :span="3" style="line-height: 30px">
            <el-button type="primary" size="small" @click="xiazai3">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px">
            <i class="el-icon-document" />
            分销客户-辖区数据({{ valueDate }}).xls
          </el-col>
        </el-row>
        <el-row style="height: 30px; margin-top: 10px" v-if="save_onoff">
          <el-col :span="5" style="line-height: 30px; font-weight: bold">辖区模板[分销]</el-col>
          <el-col :span="3" style="line-height: 30px">
            <a style="text-decoration: none; color: #ffff" class="el-button el-button--primary el-button--small"
              href="../../../static/分销客户-目标客户数据导入模板.xlsx" download="分销客户-目标客户数据导入模板.xlsx">下载</a>
          </el-col>
          <el-col :span="10" style="padding-top: 8px">
            <i class="el-icon-document" />
            分销客户-目标客户数导入据模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px" v-if="save_onoff">
          <el-col :span="4" style="line-height: 30px; font-weight: bold">
            上传数据[分销]
          </el-col>
          <el-col :span="10" style="margin-top: 3px; margin-left: 28px">
            <div style="border: 1px solid #ededed; height: 30px">
              <span style="position: relative; top: 8px; left: 5px">{{ file3 }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px; margin-left: 20px">
            <el-upload class="upload-demo" ref="upload3" accept=".xlsx,.xls" action="/wapi/v1/uploads"
              :file-list="fileList3" :show-file-list="false" :on-change="handleChange3" :on-success="handleSuccess3"
              :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small" style="
                  background-color: #7ed321;
                  border: 1px solid #7ed321;
                  color: white;
                ">选择文件
              </el-button>
              <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick3">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog title="" @open="disable1" :visible.sync="upDatamodeldialog" :show-close="false"
      id="update_jurisdictionActive">
      <div slot="title" class="dialog-footer" style="
          display: flex;
          justify-content: space-between;
          border-bottom: 2px dashed #e7eaec;
          padding: 10px 0px;
        ">
        <span style="color: #3998f7; font-size: 22px; padding-top: 5px" v-if="save_onoff">编辑辖区</span>
        <span style="color: #3998f7; font-size: 22px; padding-top: 5px" v-else>辖区详情</span>
        <span>
          <el-button @click="inputUpdata_Jurisdiction" type="primary" size="small" v-if="save_onoff">保存</el-button>
          <el-button type="danger" @click="closeUpdateDialog" size="small" v-if="save_onoff">取消</el-button>
          <el-button type="danger" @click="closeUpdateDialog" size="small" v-else>关闭</el-button>
        </span>
      </div>
      <el-form class="formSave" ref="upDataJurisdictionFrom" :model="upDataJurisdictionFrom"
        style="width: 80%; margin: auto" label-position="left" hide-required-asterisk>
        <!--                <el-form-item label="上级辖区" label-width="100px">-->
        <!--                    <el-row>-->
        <!--                        <el-col style="color: #3998f7;">-->
        <!--                            {{upDataJurisdictionFrom.topJurisdiction_name}}-->
        <!--                        </el-col>-->
        <!--                    </el-row>-->
        <!--                </el-form-item>-->
        <el-form-item label="辖区名称" label-width="100px" class="jurisdiction_star" prop="jurisdiction_name"
          :rules="[{ required: true, message: '辖区名称不能为空' }]">
          <el-input v-model="upDataJurisdictionFrom.jurisdiction_name" :disabled="!save_onoff"></el-input>
        </el-form-item>
        <el-form-item label="辖区编码" label-width="100px" class="jurisdiction_star" prop="jurisdiction_code"
          :rules="[{ required: true, message: '辖区编码不能为空' }]">
          <el-input v-model="upDataJurisdictionFrom.jurisdiction_code" :disabled="!save_onoff"></el-input>
        </el-form-item>
        <el-form-item label="辖区等级" label-width="100px">
          <!-- fuck -->
          <el-select v-model="upDataJurisdictionFrom.jurisdiction_level" placeholder="" style="width: 100%"
            :disabled="upDataJurisdictionFrom.terminalJurisdiction || !save_onoff">
            <el-option v-for="(item, index) in jurisdictionLevel" :key="index" :label="item.value1" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" label-width="100px">
          <el-input v-model="upDataJurisdictionFrom.commit" :disabled="!save_off"></el-input>
        </el-form-item>
        <el-form-item label="终端辖区" label-width="100px">
          <!--:disabled="disabledIsThree || !save_onoff"-->
          <el-switch v-model="terminal" disabled active-color="#13ce66"> </el-switch>
        </el-form-item>
        <el-form-item v-if="terminal" label="所有人" label-width="100px">
          <el-cascader :disabled="!save_onoff" style="width: 100%" v-model="upDataJurisdictionFrom.selectPeople"
            @change="changeEveryOne" :show-all-levels="false" :filterable="true" :options="JurisdictionUser"
            :props="cascader_props" clearable></el-cascader>
          <!--                    <el-select v-model="upDataJurisdictionFrom.selectPeople"  placeholder="请选择"-->
          <!--                               @change="changeEveryOne" style="width: 100%;">-->
          <!--                        <el-option-->
          <!--                                v-for="item,index in JurisdictionUser"-->
          <!--                                :key="index"-->
          <!--                                :label="item.alias"-->
          <!--                                :value="item.user_id">-->
          <!--                        </el-option>-->
          <!--                    </el-select>-->
        </el-form-item>
        <el-form-item v-if="terminal" label="覆盖城市" label-width="100px">
          <el-cascader :disabled="!save_onoff" style="width: 100%" v-model="upDataJurisdictionFrom.city"
            @change="changeEveryOne" :options="city_array" :filterable="true" :props="city_props" clearable>
          </el-cascader>
        </el-form-item>
        <el-form-item v-if="terminal" label="推广产品" label-width="100px" class="selectProduct">
          <LazySelect v-model="upDataJurisdictionFrom.product" placeholder="请选择" remote reserve-keyword
            :remote-method="remoteMethod" @scrollEnd="scrollEnd" @visibleChange="lazyVisibleChange"
            :disabled="!save_onoff" :loading="remoteLoading" :finishOptions="finishOptions"
            :loadingOptions="loadingOptions" :valueKey="{ key: 'value', label: 'product_name', value: 'product_id' }"
            :options="productList1" filterable multiple></LazySelect>
          <!--          <el-select-->
          <!--            v-model="upDataJurisdictionFrom.product"-->
          <!--            filterable-->
          <!--            value-key="product_id"-->
          <!--            multiple-->
          <!--            placeholder="请选择"-->
          <!--            style="width: 100%"-->
          <!--          >-->
          <!--            <el-option-->
          <!--              v-for="item in productList1"-->
          <!--              :key="item"-->
          <!--              :label="item.product_name"-->
          <!--              :value="item"-->
          <!--            >-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-form-item>
        <el-form-item label="是否启用" label-width="100px">
          <el-switch v-model="upDataJurisdictionFrom.status" active-color="#13ce66" active-value="ACTIVE"
            inactive-value="INACTIVE"> </el-switch>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="showModal" :show-close="false" width="900px" style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData4">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="Mechanism" stripe height="450px" style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75">
        </el-table-column>
        <el-table-column prop="yyyyMM" label="年月" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="territory_code" label="辖区编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="territory_name" label="辖区名称" min-width="120px" sortable> </el-table-column>

        <!--<el-table-column-->
        <!--prop="user_code"-->
        <!--label="代表工号"-->
        <!--min-width="150"-->
        <!--sortable>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="user_name"-->
        <!--label="代表姓名"-->
        <!--min-width="150"-->
        <!--sortable>-->
        <!--</el-table-column>-->
        <el-table-column prop="hcp_code" label="目标客户编码" min-width="150" sortable> </el-table-column>
        <el-table-column prop="hcp_name" label="目标客户姓名" min-width="150" sortable> </el-table-column>
        <el-table-column prop="segment_id" label="客户级别" min-width="120px" sortable> </el-table-column>

        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="showModal2" :show-close="false" width="900px" style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData5">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal2 = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="Mechanism2" stripe height="450px" style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75">
        </el-table-column>
        <el-table-column prop="yyyyMM" label="年月" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="territory_code" label="辖区编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="territory_name" label="辖区名称" min-width="120px" sortable> </el-table-column>

        <!--<el-table-column-->
        <!--prop="user_code"-->
        <!--label="代表工号"-->
        <!--min-width="150"-->
        <!--sortable>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="user_name"-->
        <!--label="代表姓名"-->
        <!--min-width="150"-->
        <!--sortable>-->
        <!--</el-table-column>-->
        <el-table-column prop="store_code" label="门店编码" min-width="150" sortable> </el-table-column>
        <el-table-column prop="store_name" label="门店名称" min-width="150" sortable> </el-table-column>
        <el-table-column prop="segment_id" label="客户级别" min-width="120px" sortable> </el-table-column>

        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="showModal3" :show-close="false" width="900px" style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData6">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal3 = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="Mechanism3" stripe height="450px" style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75">
        </el-table-column>
        <el-table-column prop="yyyyMM" label="年月" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="territory_code" label="辖区编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="territory_name" label="辖区名称" min-width="120px" sortable> </el-table-column>

        <!--<el-table-column-->
        <!--prop="user_code"-->
        <!--label="代表工号"-->
        <!--min-width="150"-->
        <!--sortable>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="user_name"-->
        <!--label="代表姓名"-->
        <!--min-width="150"-->
        <!--sortable>-->
        <!--</el-table-column>-->
        <el-table-column prop="distributor_code" label="经销商编码" min-width="150" sortable> </el-table-column>
        <el-table-column prop="distributor_name" label="经销商名称" min-width="150" sortable> </el-table-column>
        <el-table-column prop="segment_id" label="客户级别" min-width="120px" sortable> </el-table-column>

        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import http from '../../APIService/http'
  import jurisdiction from '../../assets/images/jurisdiction.png'
  import jurisdiction2 from '../../assets/images/jurisdiction2.png'
  import { bus } from '../../router/index.js'
  import moment from 'moment'
  import { Message } from 'element-ui'
  import xlsx from 'xlsx'
  import LazySelect from '../../components/lazySelect'

  import { export_json_to_excel } from '../../vendor/Export2Excel'
  export default {
    name: 'homeactive',
    data() {
      return {
        territoryShowStatus: true,
        file3: '',
        file2: '',
        file: '',
        loading: false,
        exportTime: '',
        modeljurisdictionExport: false,
        modeljurisdiction: false,
        styleA: true,
        styleA2: false,
        onoffBj: false,
        modelImport: false,
        input: '',
        num: 1,
        dataTime: '',
        terminal: false,
        modeldialog: false,
        form: {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          status: false,
          f: [
            { label: '1', value: '11' },
            { label: '2', value: '22' },
            { label: '3', value: '33' },
          ],
          g: [],
        },
        upKey: new Date().getTime(),
        folderArry: [],
        level: 0,
        defaultProps: {
          label: 'territory_name',
          children: 'children',
          isLeaf: 'leaf',
        },
        icon: [jurisdiction, jurisdiction2],
        territory_name: '',
        territory_region: '',
        territory_code: '',
        owner_name: '',
        owner_title: '',
        date: new Date().Format('yyyyMM'),
        isCollapse: false,
        valueDate: new Date().Format('yyyy-MM'),
        salList: '',
        index: '',
        parentNodeKey: '',
        sonNodeKey: [],
        default_ID: '',
        JurisdictionUser: [],
        addJurisdictionFrom: {
          topJurisdiction_name: '',
          topJurisdiction_id: '',
          jurisdiction_name: '',
          jurisdiction_code: '',
          jurisdiction_level: '',
          commit: '',
          terminalJurisdiction: false,
          selectPeople: '',
          city: [],
          product: [],
        },
        productList: [],
        productList1: [],
        cascader_props: {
          checkStrictly: true,
          value: 'ou_id',
          label: 'label',
          disabled: 'disabled',
          emitPath: false,
        },
        city_props: {
          value: 'id',
          label: 'label',
          multiple: true,
        },

        jurisdictionLevel: [],
        upDataJurisdictionFrom: {
          topJurisdiction_name: '',
          topJurisdiction_id: '',
          jurisdiction_id: '',
          jurisdiction_name: '',
          jurisdiction_code: '',
          jurisdiction_level: '',
          commit: '',
          terminalJurisdiction: false,
          selectPeople: '',
          month: '',
          city: [],
          product: [],
          status: ""
        },

        upDatamodeldialog: false,
        nodeData: {},
        dataNode: {},
        save_onoff: true,
        saveOff: true,
        isUpload: false,
        isUpload2: false,
        isUpload3: false,
        fileList: [],
        fileList2: [],
        fileList3: [],
        AccountHcp: [],
        AccountDistributor: [],
        showModal: false,
        showModal2: false,
        showModal3: false,
        arr: [],
        arr2: [],
        arr3: [],
        Mechanism: [],
        Mechanism2: [],
        Mechanism3: [],
        currentNode: null,
        currentNodeResolve: null,
        ter_id: '',
        isseach: false,
        search_data: {},
        disabledIsThree: false,
        city_array: [],
        ismanager: this.$store.getters.getUser.role === 'staff' ? false : true,
        infoObj: {},
        excelData: [],
        excelData2: [],
        excelData3: [],
        loadingText: '拼命加载中',
        record: [],
        errData: '',
        errData2: '',
        errData3: '',
        remoteLoading: false,
        loadingOptions: false,
        finishOptions: false,
        optionsQuery: '',
        optionsPage: 1,
        remoteLoadingAdd: false,
        loadingOptionsAdd: false,
        finishOptionsAdd: false,
        optionsQueryAdd: '',
        optionsPageAdd: 1,
      }
    },
    components: {
      LazySelect,
    },
    methods: {
      handleActive() {
        this.init();
      },
      async lazyVisibleChange() {
        this.optionsQuery = ''
        this.optionsPage = 1
        if (this.isseach === true) {
          await this.getProductList1(this.search_data.territory_id)
        } else {
          await this.getProductList1(this.nodeData.parent.data.territory_id)
        }
      },
      //远程选项滚动到底
      async scrollEnd() {
        this.optionsPage += 1
        this.loadingOptions = true
        if (this.isseach === true) {
          await this.getProductList1(this.search_data.territory_id)
        } else {
          await this.getProductList1(this.nodeData.parent.data.territory_id)
        }
        this.loadingOptions = false
      },
      //远程搜索
      async remoteMethod(query) {
        this.optionsQuery = query
        this.optionsPage = 1
        this.remoteLoading = true
        this.finishOptions = false
        if (this.isseach === true) {
          await this.getProductList1(this.search_data.territory_id)
        } else {
          await this.getProductList1(this.nodeData.parent.data.territory_id)
        }
        this.remoteLoading = false
        this.upDataJurisdictionFrom.product = [...this.upDataJurisdictionFrom.product]
      },

      async lazyVisibleChangeAdd() {
        this.optionsQueryAdd = ''
        this.optionsPageAdd = 1
        await this.getProductList()
      },
      //远程选项滚动到底
      async scrollEndAdd() {
        this.optionsPageAdd += 1
        this.loadingOptionsAdd = true
        await this.getProductList()
        this.loadingOptionsAdd = false
      },
      //远程搜索
      async remoteMethodAdd(query) {
        this.optionsQueryAdd = query
        this.optionsPageAdd = 1
        this.remoteLoadingAdd = true
        this.finishOptionsAdd = false
        await this.getProductList()
        this.remoteLoadingAdd = false
        this.addJurisdictionFrom.product = [...this.addJurisdictionFrom.product]
      },

      daochu() {
        this.modeljurisdictionExport = true
        this.file = ''
        this.file2 = ''
        this.file3 = ''
      },
      async handleSelect(item) {
        try {
          let user = this.$store.getters.getUser
          let obj = {
            tenant_id: user.tenant_id,
            user_id: user.user_id,
            territory_id: item.territory_id,
            month: this.valueDate,
          }
          this.default_ID = item.territory_id
          this.$nextTick(() => {
            this.$refs.menusTreeAc.setCurrentKey(item.territory_id)
          })
          await http.post('/wapi/JurActive/selectJur', obj).then((res) => {
            let data = res.data[0]
            this.search_data = data
            data.save_onoff = this.save_onoff
            if (data.territory_type === 'CONTAINER') {
              this.terminal = false
              // data.status = 'on'
              this.$store.commit('setDataInfo', data)
              // if (this.$route.fullPath === "/territoryActive/indexActive") {
              //   this.$router.push({ path: "indexActiveTow" });
              // } else {
              this.$router.push({ path: 'indexActive', query: { d: (this.upKey = new Date().getTime()) } })
              // }
            } else {
              this.getJurisdictionUser(item.territory_id)
              if (data.parent_territory == '') {
                this.terminal = false
              } else {
                this.terminal = true
              }
              // data.status = 'on'

              this.$store.commit('setDataInfo', data)
              // if (this.$route.fullPath === "/territoryActive/insActive") {
              //   this.$router.push({
              //     path: "insActiveTow",
              //   });
              // } else {
              this.$router.push({
                path: 'insActive',
                query: { d: (this.upKey = new Date().getTime()) },
              })
              // }
            }
            this.territory_name = data.territory_name
            if (data.territory_type === 'CONTAINER') {
              this.territory_region = '地区'
            } else {
              this.territory_region = '终端'
            }
            this.territory_level_name = data.territory_level_name
            this.territory_code = data.territory_code
            this.owner_name = data.owner_name
            this.owner_title = data.title
            this.salList = data.salseList.length
            this.isseach = true
          })
        } catch (e) { }

        //
        // this.recursion()
      },
      async search(queryString, cb) {
        this.input = queryString.trim()
        this.queryString = queryString.trim()
        if (queryString) {
          try {
            var user = this.$store.getters.getUser
            let data = {
              tenant_id: user.tenant_id,
              search: this.queryString.trim(),
              month: this.valueDate,
              show_inactive: this.territoryShowStatus ? "T" : "F"
            }
            // console.log(data)
            await http.post('/wapi/JurActive/searchJur', data).then((res) => {
              if (res.success) {
                cb(res.data)
              }
            })
          } catch (err) {
            this.error()
          }
        } else {
          cb([])
          this.$refs.tree.filter()
        }
      },
      closeModal() {
        this.excelData = []
        this.excelData2 = []
        this.excelData3 = []
        this.fileList = []
        this.fileList3 = []
        this.fileList2 = []
        this.modeljurisdictionExport = false
        this.isUpload = false
        this.isUpload3 = false
        this.isUpload2 = false
      },
      // imortDataClick() {
      //   if (this.isUpload) {
      //     this.$refs.upload.submit()
      //   } else {
      //     Message({
      //       showClose: true,
      //       message: '导入模板不能为空',
      //       type: 'error'
      //     })
      //   }
      // },
      async imortDataClick() {
        if (this.excelData.length === 0) {
          this.$message.error('请选择导入模板！')
          return false
        }
        this.loading = true
        this.loadingText = `正在导入数据0%(0/${this.excelData.length - 1})`
        this.errData = ''
        this.record = []
        let herder = this.excelData[0]
        let res = await this.importData(herder, this.excelData.slice(1), 0, 500, this.excelData.length - 1)

        if (!res) {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success('导入成功')
            this.loadingText = '拼命加载中'
            this.loading = false
            if (this.errData.length > 0) {
              this.showModal = true
              this.Mechanism = this.errData.slice(0, 100)
            }
          } else {
            this.$message.error('导入失败')
            this.loading = false
            this.loadingText = '拼命加载中'
          }
        }
      },
      async importData(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true
          }
          let data = {
            progressNum: page * limit,
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          }

          let response = await http.post('/wapi/excel/imortAccountHcp', data)
          if (!response) {
            return false
          }
          if (response.statusCode === 502) {
            return await this.importData(herder, excelData, page, limit, size)
          }
          this.loadingText =
            '正在导入数据' +
            (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
          this.loadingText += progressText

          if (response.success) {
            this.record.push(true)
            if (response.data) {
              if (!this.errData) {
                this.errData = []
              }
              this.errData = [...this.errData, ...response.data]
            }
          } else {
            this.record.push(false)
          }
          return await this.importData(herder, excelData, page + 1, limit, size)
        } catch (e) {
          return false
        }
      },
      async imortDataClick2() {
        if (this.excelData2.length === 0) {
          this.$message.error('请选择导入模板！')
          return false
        }
        this.loading = true
        this.loadingText = `正在导入数据0%(0/${this.excelData2.length - 1})`
        this.errData2 = ''
        this.record = []
        let herder = this.excelData2[0]
        let res = await this.importData2(herder, this.excelData2.slice(1), 0, 500, this.excelData2.length - 1)

        if (!res) {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success('导入成功')
            this.loadingText = '拼命加载中'
            this.loading = false
            if (this.errData2.length > 0) {
              this.showModal2 = true
              this.Mechanism2 = this.errData2.slice(0, 100)
            }
          } else {
            this.$message.error('导入失败')
            this.loading = false
            this.loadingText = '拼命加载中'
          }
        }
      },
      async importData2(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true
          }
          let data = {
            progressNum: page * limit,
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          }

          let response = await http.post('/wapi/excel/imortAccountRetailStore', data)
          if (!response) {
            return false
          }
          if (response.statusCode === 502) {
            return await this.importData2(herder, excelData, page, limit, size)
          }
          this.loadingText =
            '正在导入数据' +
            (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
          this.loadingText += progressText

          if (response.success) {
            this.record.push(true)
            if (response.data) {
              if (!this.errData2) {
                this.errData2 = []
              }
              this.errData2 = [...this.errData2, ...response.data]
            }
          } else {
            this.record.push(false)
          }
          return await this.importData2(herder, excelData, page + 1, limit, size)
        } catch (e) {
          return false
        }
      },
      async imortDataClick3() {
        if (this.excelData3.length === 0) {
          this.$message.error('请选择导入模板！')
          return false
        }
        this.loading = true
        this.loadingText = `正在导入数据0%(0/${this.excelData3.length - 1})`
        this.errData3 = ''
        this.record = []
        let herder = this.excelData3[0]
        let res = await this.importData3(herder, this.excelData3.slice(1), 0, 500, this.excelData3.length - 1)

        if (!res) {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success('导入成功')
            this.loadingText = '拼命加载中'
            this.loading = false
            if (this.errData3.length > 0) {
              this.showModal3 = true
              this.Mechanism3 = this.errData3.slice(0, 100)
            }
          } else {
            this.$message.error('导入失败')
            this.loading = false
            this.loadingText = '拼命加载中'
          }
        }
      },
      async importData3(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true
          }
          let data = {
            progressNum: page * limit,
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          }

          let response = await http.post('/wapi/excel/imortAccountDistributor', data)
          if (!response) {
            return false
          }
          if (response.statusCode === 502) {
            return await this.importData3(herder, excelData, page, limit, size)
          }
          this.loadingText =
            '正在导入数据' +
            (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
          this.loadingText += progressText

          if (response.success) {
            this.record.push(true)
            if (response.data) {
              if (!this.errData3) {
                this.errData3 = []
              }
              this.errData3 = [...this.errData3, ...response.data]
            }
          } else {
            this.record.push(false)
          }
          return await this.importData3(herder, excelData, page + 1, limit, size)
        } catch (e) {
          return false
        }
      },
      // imortDataClick2() {
      //   if (this.isUpload2) {
      //     this.$refs.upload2.submit()
      //   } else {
      //     Message({
      //       showClose: true,
      //       message: '导入模板不能为空',
      //       type: 'error'
      //     })
      //   }
      // },
      // imortDataClick3() {
      //   if (this.isUpload3) {
      //     this.$refs.upload3.submit()
      //   } else {
      //     Message({
      //       showClose: true,
      //       message: '导入模板不能为空',
      //       type: 'error'
      //     })
      //   }
      // },
      // handleChange(file, fileList) {
      //
      //   this.file = file.name
      //   const nameArr = file.name.split('.')
      //   const extension = nameArr[nameArr.length - 1] === 'xlsx'
      //   const isLt2M = file.size / 1024 / 1024 < 10
      //   if (!extension) {
      //     this.file = ''
      //     this.fileList = []
      //     Message({
      //       showClose: true,
      //       message: '上传模板只能是xlsx',
      //       type: 'error'
      //     })
      //   }
      //   if (!isLt2M) {
      //     this.file = ''
      //     this.fileList = []
      //     Message({
      //       showClose: true,
      //       message: '传模板大小不能超过 10MB',
      //       type: 'error'
      //     })
      //   }
      //   this.isUpload = true
      //
      //   return extension && isLt2M
      // },

      //     async handleSuccess(res, file) {
      //       // console.log(res)
      //
      //       const loading = this.$loading({
      //         lock: true,
      //         text: '拼命加载中',
      //         spinner: 'el-icon-loading',
      //         background: 'rgba(0, 0, 0, 0.7)'
      //       });
      //       if (res.success) {
      //         try {
      // //                        var user = this.$store.getters.getUser
      //
      //           let data = {
      //             user_id: this.$store.getters.getUser.user_id,
      //             tenant_id: this.$store.getters.getUser.tenant_id,
      //             path: res.data,
      //           }
      //
      //           await http.post('/wapi/excel/imortAccountHcp', data).then(res => {
      //             loading.close()
      //             if (res.success) {
      //               this.closeModal()
      //               if (res.data.length == 0) {
      //                 Message({
      //                   type: 'success',
      //                   message: '导入成功'
      //                 })
      //               } else {
      //                 this.showModal = true
      //                 this.Mechanism = [...res.data]
      //                 this.arr = [...res.data]
      //                 Message({
      //                   type: 'success',
      //                   message: '导入成功'
      //                 })
      //               }
      //
      //             } else {
      //               this.fileList = []
      //
      //               Message({
      //                 type: 'error',
      //                 message: '导入失败'
      //               })
      //             }
      //
      //             this.loading = false
      //           })
      //         } catch (err) {
      //           loading.close()
      //           Message.error('导入失败！')
      //         }
      //       } else {
      //         loading.close()
      //         Message.error('导入失败！')
      //       }
      //     },
      async getParsingFile(fileName) {
        return new Promise(function (resolve, reject) {
          //定义reader，存放文件读取方法
          let reader = new FileReader()

          //启动函数
          reader.readAsBinaryString(fileName)
          //onload文件读取成功
          reader.onload = function (e) {
            //workbook存放excel的所有基本信息
            let workbook = xlsx.read(e.target.result, { type: 'binary' })
            xlsx.onprogress = function (e) { }
            //定义sheetList中存放excel表格的sheet表，就是最下方的tab
            let sheetList = workbook.SheetNames

            //存放json数组格式的表格数据
            let resultJson = []
            if (sheetList.length > 1) {
              reject({ status: false, message: '模板错误,不能有1个以上sheet' })
            }
            sheetList.forEach(function (y) {
              let worksheet = workbook.Sheets[y]
              resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], {
                defval: '',
              })
            })

            if (resultJson.length === 0) {
              resolve({ status: true, data: resultJson })
            }
            //取出表头
            let tableHeader = Object.keys(resultJson[0])

            //取出表数据
            let importInfo = resultJson.map((item) => {
              return tableHeader.map((v) => item[v])
            })

            importInfo = [tableHeader, ...importInfo]
            resolve({ status: true, data: importInfo })
          }
          //文件读取失败
          reader.onerror = function (e) {
            reject({ status: false, message: '解析失败' })
          }
        })
      },
      async handleChange(file, fileList) {
        this.loading = true
        this.$refs.upload.clearFiles()
        this.loadingText = '文件解析中'
        let res = await this.getParsingFile(file.raw)

        setTimeout(() => {
          this.loading = false
          this.loadingText = '拼命加载中'
        }, 1000)
        if (!res.status) {
          this.$message.error(res.message)
          this.fileList = []
          return
        }
        if (res.data.length === 0 || res.data[0].length !== 6 || res.data[0][0].trim() !== '年月') {
          this.$message.error('模板错误，请选择正确的模板')
          this.fileList = []
          return false
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error('导入数据必须大于0条')
          this.fileList = []
          return false
        }
        if (fileList.length !== 0 && res) {
          this.file = file.name
        }
        this.excelData = res.data
      },
      async handleChange2(file, fileList) {
        this.loading = true
        this.$refs.upload2.clearFiles()
        this.loadingText = '文件解析中'
        let res = await this.getParsingFile(file.raw)

        setTimeout(() => {
          this.loading = false
          this.loadingText = '拼命加载中'
        }, 1000)
        if (!res.status) {
          this.$message.error(res.message)
          this.fileList2 = []
          return
        }
        if (res.data.length === 0 || res.data[0].length !== 6 || res.data[0][0].trim() !== '年月') {
          this.$message.error('模板错误，请选择正确的模板')
          this.fileList2 = []
          return false
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error('导入数据必须大于0条')
          this.fileList2 = []
          return false
        }
        if (fileList.length !== 0 && res) {
          this.file2 = file.name
        }
        this.excelData2 = res.data
      },
      async handleChange3(file, fileList) {
        this.loading = true
        this.$refs.upload3.clearFiles()
        this.loadingText = '文件解析中'
        let res = await this.getParsingFile(file.raw)

        setTimeout(() => {
          this.loading = false
          this.loadingText = '拼命加载中'
        }, 1000)
        if (!res.status) {
          this.$message.error(res.message)
          this.fileList3 = []
          return
        }
        if (res.data.length === 0 || res.data[0].length !== 6 || res.data[0][0].trim() !== '年月') {
          this.$message.error('模板错误，请选择正确的模板')
          this.fileList3 = []
          return false
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error('导入数据必须大于0条')
          this.fileList3 = []
          return false
        }
        if (fileList.length !== 0 && res) {
          this.file3 = file.name
        }
        this.excelData3 = res.data
      },
      // handleChange2(file, fileList) {
      //
      //   this.file2 = file.name
      //   const nameArr = file.name.split('.')
      //   const extension = nameArr[nameArr.length - 1] === 'xlsx'
      //   const isLt2M = file.size / 1024 / 1024 < 10
      //   if (!extension) {
      //     this.file = ''
      //     this.fileList2 = []
      //     Message({
      //       showClose: true,
      //       message: '上传模板只能是xlsx',
      //       type: 'error'
      //     })
      //   }
      //   if (!isLt2M) {
      //     this.file = ''
      //     this.fileList2 = []
      //     Message({
      //       showClose: true,
      //       message: '传模板大小不能超过 10MB',
      //       type: 'error'
      //     })
      //   }
      //   this.isUpload2 = true
      //
      //   return extension && isLt2M
      // },
      async handleSuccess2(res, file) {
        // console.log(res)

        const loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        if (res.success) {
          try {
            //                        var user = this.$store.getters.getUser

            let data = {
              user_id: this.$store.getters.getUser.user_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              path: res.data,
            }

            await http.post('/wapi/excel/imortAccountRetailStore', data).then((res) => {
              loading.close()
              if (res.success) {
                this.closeModal()
                if (res.data.length == 0) {
                  Message({
                    type: 'success',
                    message: '导入成功',
                  })
                } else {
                  this.showModal2 = true
                  this.Mechanism2 = [...res.data]
                  this.arr2 = [...res.data]
                  Message({
                    type: 'success',
                    message: '导入成功',
                  })
                }
              } else {
                this.fileList2 = []

                Message({
                  type: 'error',
                  message: '导入失败',
                })
              }

              this.loading = false
            })
          } catch (err) {
            loading.close()
            Message.error('导入失败！')
          }
        } else {
          loading.close()
          Message.error('导入失败！')
        }
      },
      // handleChange3(file, fileList) {
      //
      //   this.file3 = file.name
      //   const nameArr = file.name.split('.')
      //   const extension = nameArr[nameArr.length - 1] === 'xlsx'
      //   const isLt2M = file.size / 1024 / 1024 < 10
      //   if (!extension) {
      //     this.file = ''
      //     this.fileList3 = []
      //     Message({
      //       showClose: true,
      //       message: '上传模板只能是xlsx',
      //       type: 'error'
      //     })
      //   }
      //   if (!isLt2M) {
      //     this.file = ''
      //     this.fileList3 = []
      //     Message({
      //       showClose: true,
      //       message: '传模板大小不能超过 10MB',
      //       type: 'error'
      //     })
      //   }
      //   this.isUpload3 = true
      //
      //   return extension && isLt2M
      // },
      async handleSuccess3(res, file) {
        // console.log(res)

        const loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        if (res.success) {
          try {
            //                        var user = this.$store.getters.getUser

            let data = {
              user_id: this.$store.getters.getUser.user_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              path: res.data,
            }

            await http.post('/wapi/excel/imortAccountDistributor', data).then((res) => {
              loading.close()
              if (res.success) {
                this.closeModal()
                if (res.data.length == 0) {
                  Message({
                    type: 'success',
                    message: '导入成功',
                  })
                } else {
                  this.showModal3 = true
                  this.Mechanism3 = [...res.data]
                  this.arr3 = [...res.data]
                  Message({
                    type: 'success',
                    message: '导入成功',
                  })
                }
              } else {
                this.fileList3 = []

                Message({
                  type: 'error',
                  message: '导入失败',
                })
              }

              this.loading = false
            })
          } catch (err) {
            loading.close()
            Message.error('导入失败！')
          }
        } else {
          loading.close()
          Message.error('导入失败！')
        }
      },
      xiazai() {
        this.deriveAccountHcp()
      },
      xiazai3() {
        this.deriveAccountDistributor()
      },
      xiazai2() {
        this.deriveAccountRetailStore()
      },
      async deriveAccountHcp() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          // month: this.date,
          month:moment(this.valueDate).format('YYYYMM'),
        }
        let self = this
        await http
          .post('/wapi/derive/deriveAccountHcp', data)
          .then((res) => {
            self.AccountHcp = res
            // console.log(self.AccountHcp)
            this.handleExportData()
          })
          .catch((err) => {
            Message({
              type: 'error',
              message: '下载失败',
            })
          })
      },
      async deriveAccountDistributor() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          // month: this.date,
          month:moment(this.valueDate).format('YYYYMM'),
        }
        let self = this
        await http
          .post('/wapi/derive/deriveAccountDistributor', data)
          .then((res) => {
            self.AccountDistributor = res
            // console.log(self.AccountDistributor)
            this.handleExportData2()
          })
          .catch((err) => {
            Message({
              type: 'error',
              message: '下载失败',
            })
          })
      },
      async deriveAccountRetailStore() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          // month: this.date,
          month:moment(this.valueDate).format('YYYYMM'),
        }
        let self = this
        await http
          .post('/wapi/derive/deriveAccountRetailStore', data)
          .then((res) => {
            self.AccountRetailStore = res
            // console.log(self.AccountRetailStore)
            this.handleExportData3()
          })
          .catch((err) => {
            Message({
              type: 'error',
              message: '下载失败',
            })
          })
      },
      handleExportData() {
        try {
          import('@/vendor/Export2Excel').then((excel) => {
            const tHeader = ['月份', '辖区编码', '辖区名称', '机构编码', '机构名称', '产品编码', '产品名称']
            const filterVal = [
              'month',
              'territory_code',
              'territory_name',
              'institution_code',
              'institution_name',
              'product_code',
              'product_name',
            ]

            const list = this.AccountHcp
            const data = this.formatJson(filterVal, list)

            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '辖区数据[医务]',
              autoWidth: this.autoWidth,
            })
          })
          this.loading = false
        } catch (err) {
          this.loading = false
          this.error()
        }
      },
      handleExportData2() {
        try {
          import('@/vendor/Export2Excel').then((excel) => {
            const tHeader = ['月份', '辖区编码', '辖区名称', '经销商编码', '经销商名称', '产品编码', '产品名称']
            const filterVal = [
              'month',
              'territory_code',
              'territory_name',
              'distributor_code',
              'distributor_name',
              'product_code',
              'product_name',
            ]

            const list = this.AccountDistributor
            const data = this.formatJson(filterVal, list)

            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '辖区数据[分销]',
              autoWidth: this.autoWidth,
            })
          })
          this.loading = false
        } catch (err) {
          this.loading = false
          this.error()
        }
      },
      handleExportData3() {
        try {
          import('@/vendor/Export2Excel').then((excel) => {
            const tHeader = ['月份', '辖区编码', '辖区名称', '门店编码', '门店名称', '产品编码', '产品名称']
            const filterVal = [
              'month',
              'territory_code',
              'territory_name',
              'store_code',
              'store_name',
              'product_code',
              'product_name',
            ]

            const list = this.AccountRetailStore
            const data = this.formatJson(filterVal, list)

            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '辖区数据[零售]',
              autoWidth: this.autoWidth,
            })
          })
          this.loading = false
        } catch (err) {
          this.loading = false
          this.error()
        }
      },
      obj_to_arr(names, data) {
        return data.map((item) => {
          let arr = []
          names.forEach((name) => {
            arr.push(item[name])
          })
          return arr
        })
      },
      downloadErrorExcel(header, data, page = 0, limit = 5000) {
        try {
          if (page * limit >= data.length) {
            return true
          }

          //错误数据
          let tHeader = header
          let tData = data.slice(page * limit, (page + 1) * limit)
          export_json_to_excel({
            header: tHeader,
            data: tData,
            filename: '错误信息' + (!page ? '' : page),
          })
          this.loadingText = `正在下载错误数据0% (${(page + 1) * limit} / ${data.length})`
          this.downloadErrorExcel(header, data, page + 1, limit)
        } catch (err) {
          this.loading = false
          this.loadingText = '拼命加载中'
          this.$message.error('下载失败！')
        }
      },
      handleExportData4() {
        try {
          this.loading = true
          let tHeader = ['年月', '辖区编码', '辖区名称', '目标客户编码', '目标客户姓名', '客户级别', '报错信息']
          let names = ['yyyyMM', 'territory_code', 'territory_name', 'hcp_code', 'hcp_name', 'segment_id', 'message']
          let data = this.obj_to_arr(names, this.errData)
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
          this.downloadErrorExcel(tHeader, data, 0, 20000)
          //错误数据
          this.loading = false
          this.loadingText = '拼命加载中'
        } catch (err) {
          this.loading = false
          this.loadingText = '拼命加载中'
          this.$message.error('下载失败！')
        }
      },
      handleExportData5() {
        try {
          this.loading = true
          let tHeader = ['年月', '辖区编码', '辖区名称', '门店编码', '门店名称', '客户级别', '报错信息']
          let names = ['yyyyMM', 'territory_code', 'territory_name', 'store_code', 'store_name', 'segment_id', 'message']
          let data = this.obj_to_arr(names, this.errData2)
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
          this.downloadErrorExcel(tHeader, data, 0, 20000)
          //错误数据
          this.loading = false
          this.loadingText = '拼命加载中'
        } catch (err) {
          this.loading = false
          this.loadingText = '拼命加载中'
          this.$message.error('下载失败！')
        }
      },
      handleExportData6() {
        try {
          this.loading = true
          let tHeader = ['年月', '辖区编码', '辖区名称', '经销商编码', '经销商名称', '客户级别', '报错信息']
          let names = [
            'yyyyMM',
            'territory_code',
            'territory_name',
            'distributor_code',
            'distributor_name',
            'segment_id',
            'message',
          ]
          let data = this.obj_to_arr(names, this.errData3)
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
          this.downloadErrorExcel(tHeader, data, 0, 20000)
          //错误数据
          this.loading = false
          this.loadingText = '拼命加载中'
        } catch (err) {
          this.loading = false
          this.loadingText = '拼命加载中'
          this.$message.error('下载失败！')
        }
      },
      // handleExportData4() {
      //   try {
      //     import('@/vendor/Export2Excel').then(excel => {
      //       const tHeader = ['年月', '辖区编码', '辖区名称', '目标客户编码', '目标客户姓名', '客户级别', '报错信息']
      //       const filterVal = [
      //         'yyyyMM',
      //         'territory_code',
      //         'territory_name',
      //         'hcp_code',
      //         'hcp_name',
      //         'segment_id',
      //         'message'
      //       ]
      //       let arr = [...this.arr]
      //       for (var i = 0; i < arr.length; i++) {
      //         let obj = arr[i].message.join(" ")
      //         arr[i].message = obj
      //       }
      //
      //       const list = arr
      //       const data = this.formatJson(filterVal, list)
      //
      //       excel.export_json_to_excel({
      //         header: tHeader,
      //         data,
      //         filename: '报错信息表',
      //         autoWidth: this.autoWidth
      //       })
      //     })
      //     this.loading = false
      //     this.showModal = false
      //   } catch (err) {
      //     this.loading = false
      //     this.error()
      //   }
      // },
      // handleExportData5() {
      //   try {
      //     import('@/vendor/Export2Excel').then(excel => {
      //       const tHeader = ['年月', '辖区编码', '辖区名称', '目标客户编码', '目标客户姓名', '客户级别', '报错信息']
      //       const filterVal = [
      //         'yyyyMM',
      //         'territory_code',
      //         'territory_name',
      //         'store_code',
      //         'store_name',
      //         'segment_id',
      //         'message'
      //       ]
      //       let arr = [...this.arr2]
      //       for (var i = 0; i < arr.length; i++) {
      //         let obj = arr[i].message.join(" ")
      //         arr[i].message = obj
      //       }
      //
      //       const list = arr
      //       const data = this.formatJson(filterVal, list)
      //
      //       excel.export_json_to_excel({
      //         header: tHeader,
      //         data,
      //         filename: '报错信息表',
      //         autoWidth: this.autoWidth
      //       })
      //     })
      //     this.loading = false
      //     this.showModal2 = false
      //   } catch (err) {
      //     this.loading = false
      //     this.error()
      //   }
      // },
      // handleExportData6() {
      //   try {
      //     import('@/vendor/Export2Excel').then(excel => {
      //       const tHeader = ['年月', '辖区编码', '辖区名称', '目标客户编码', '目标客户姓名', '客户级别', '报错信息']
      //       const filterVal = [
      //         'yyyyMM',
      //         'territory_code',
      //         'territory_name',
      //         'distributor_code',
      //         'distributor_name',
      //         'segment_id',
      //         'message'
      //       ]
      //       let arr = [...this.arr3]
      //       for (var i = 0; i < arr.length; i++) {
      //         let obj = arr[i].message.join(" ")
      //         arr[i].message = obj
      //       }
      //
      //       const list = arr
      //       const data = this.formatJson(filterVal, list)
      //
      //       excel.export_json_to_excel({
      //         header: tHeader,
      //         data,
      //         filename: '报错信息表',
      //         autoWidth: this.autoWidth
      //       })
      //     })
      //     this.loading = false
      //     this.showModal3 = false
      //   } catch (err) {
      //     this.loading = false
      //     this.error()
      //   }
      // },
      formatJson(filterVal, jsonData) {
        return jsonData.map((v) => filterVal.map((j) => v[j]))
      },
      async getJurisdictionUser(territory_id) {
        try {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id;
          data.territory_id = territory_id;
          ///wapi/JurActive/getJurisdictionUser
          await http.post('/crm/users/admin/getJurisdictionUser', data).then((res) => {
            if (res.success === true) {
              this.JurisdictionUser = res.data
            }
          })
        } catch (e) { }
      },
      //获取城市
      async getCity() {
        try {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          await http.post('/wapi/JurActive/getCity', data).then((res) => {
            // console.log(res)
            if (res.success === true) {
              this.city_array = res.data
            }
          })
        } catch (e) { }
      },
      async getProductList() {
        try {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.user_id = this.$store.getters.getUser.user_id
          data.search = this.optionsQueryAdd
          data.page = this.optionsPageAdd
          await http.post('/wapi/JurActive/getProductList_home', data).then((res) => {
            // console.log(res)
            if (res.success === true) {
              if (res.data.length < 20) {
                this.finishOptionsAdd = true
              }
              if (data.page === 1) {
                this.productList = res.data
              } else {
                this.productList = this.productList.concat(res.data)
              }
            }
          })
        } catch (e) { }
      },
      refreshNodeBy(id) {
        if (id) {
          let node = this.$refs.menusTreeAc.getNode(id) // 通过节点id找到对应树节点对象
          if (node) {
            node.loaded = false
            node.expand() // 主动调用展开节点方法，重新查询该节点下的所有子节点
          }
        } else {
          this.init()
        }
      },
      handleNodeClick(data, node, ele) {
        this.isseach = false
        this.parentNodeKey = node.parent.data.territory_id
        this.sonNodeKey = node.data.territory_id
        this.getTerritoryInfo(data, node)
        //  this.styleA = true
        //  this.styleA2 = false
        //  this.level = item2.level
        // if (item2.level === 2 || item2.level === 1){
        //     this.$router.push('/jurisdiction/index')
        // }else if (item2.level === 3){
        //     this.$router.push('/jurisdiction/institutions')
        // }
      },
      async getTerritoryInfo(territoryObj, node) {
        try {
          this.loading = true
          let data = {}
          data.month = this.valueDate
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.territory_id = territoryObj.territory_id

          await http.post('/wapi/JurActive/getTerritoryInfo', data).then((res) => {
            // let obj = res
            // let info = Object.assign(obj,territoryObj)
            //    info.changesSalseList=[]
            //     this.$store.commit('setDataInfo', info)

            this.infoObj = res.data
            this.nodeData = node
            this.nodeData.data = Object.assign(node.data, res.data)
            // this.dataNode = data
            this.loading = false
            this.$nextTick().then(() => {
              let data = Object.assign(this.infoObj, territoryObj)
              data.save_onoff = this.save_onoff
              if (data.territory_type === 'CONTAINER') {
                this.saveOff = false
                this.terminal = false
                // data.status = 'on'

                this.$store.commit('setDataInfo', data)
                // if (this.$route.fullPath === "/territoryActive/indexActive") {
                //   this.$router.push({ path: "indexActiveTow" });
                // } else {
                this.$router.push({ path: 'indexActive', query: { d: (this.upKey = new Date().getTime()) } })
                // }
              } else {
                this.getJurisdictionUser(territoryObj.territory_id)
                if (data.parent_territory == '') {
                  this.terminal = false
                } else {
                  this.terminal = true
                }
                this.saveOff = true

                // data.status = 'on'
                this.$store.commit('setDataInfo', data)
                // if (this.$route.fullPath === "/territoryActive/insActive") {
                //   this.$router.push({
                //     path: "insActiveTow",
                //   });
                // } else {
                this.$router.push({
                  path: 'insActive',
                  query: { d: (this.upKey = new Date().getTime()) },
                })
                // }
              }
              this.territory_name = data.territory_name
              if (data.territory_type === 'CONTAINER') {
                this.territory_region = '地区'
              } else {
                this.territory_region = '终端'
              }
              this.territory_level_name = data.territory_level_name
              this.territory_code = data.territory_code
              this.owner_name = data.owner_name
              this.owner_title = data.title
              this.salList = data.salseList.length
            })
          })
        } catch (e) { }
      },
      importExport() {
        this.modelImport = true
      },
      changeEveryOne(item) {
        // console.log(item)
        // console.log(this.form)
      },
      effectNo() {
        this.onoffBj = true
        // this.styleA = true
        // this.styleA2 = false
        this.$router.push('/territory/index')
        // if (this.level === 2){
        //     this.$router.push('/jurisdiction/index')
        // } else {
        //     this.$router.push('/jurisdiction/institutions')
        // }
      },
      effectOff() {
        this.onoffBj = false
        // this.styleA = false
        // this.styleA2 = true
        this.$router.push('/territoryActive/indexActive')
        // if (this.$route.fullPath === '/jurisdiction/index')
        // {
        //     this.$router.push({path:'index2Tow'})
        // }else {
        //     this.$router.push({path:'index2'})
        // }
        // if (this.level === 2){
        //     this.$router.push('/jurisdiction/index2')
        // } else {
        //     this.$router.push('/jurisdiction/institutions2')
        // }
      },
      handleNodeExpand(a, b, c) {
        // console.log(a)
        // console.log(b)
        // console.log(c)
      },
      loadNode(node, resolve) {
        this.getLoadNode(node, resolve).then(() => {
          setTimeout(() => {
            this.default_ID = this.nodeData.data.territory_id
            this.$refs.menusTreeAc.setCurrentKey(this.default_ID)
          }, 100)
        })
        // console.log(node)
      },
      async getLoadNode(node, resolve) {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          month: this.valueDate,
          territory_id: node.data.territory_id,
        }

        if (node.level > 0) {
          await http.post('/wapi/JurActive/jurisdiction_m', data).then((res) => {
            // console.log(res)
            for (let i = 0; i < res.length; i++) {
              if (res[i].territory_type === 'ENDPOINT' || res[i].isThereData === 0) {
                res[i].leaf = true
              }
            }
            resolve(res)
            for (let i = 0; i < res.length; i++) {
              if (this.nodeData.data.territory_id === res[i].territory_id) {
                this.nodeData.data = res[i]
                this.territory_name = this.nodeData.data.territory_name
              }
            }
          })
        }
      },
      async init(key) {
        try {
          this.loading = true
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.user_id = this.$store.getters.getUser.user_id
          data.month = this.valueDate
          data.show_inactive = this.territoryShowStatus ? "T" : "F"
          await http.post('/wapi/JurActive/jurisdiction_m', data).then((res) => {
            let array = res
            // array.forEach(item=>{
            //     item.children= []
            //     for (let i=0;i<item.productArray.length;i++){
            //         item.children.push({territory_name:item.productArray[i]})
            //     }
            //
            // })
            this.folderArry = array
            //console.log(this.folderArry)
            this.$nextTick().then(() => {
              // const firstNode = document.querySelector(".el-tree-node");
              // firstNode.click();
              key = key || this.folderArry[0].territory_id
              let node = this.$refs.menusTreeAc.getNode(key)

              // node.parent.level ? node.parent.expand() : node.expand();
              this.default_ID = key
              this.$refs.menusTreeAc.setCurrentKey(key)
              this.handleNodeClick(node.data, node)
            })
            this.loading = false
          })
        } catch (e) { }
      },
      clickTab(item) {
        if (item === 'inactive') {
          this.$router.push('/territory/index')
        } else if (item === 'active') {
          // this.$router.push("/territoryActive/indexActive");
        }
      },
      addJurisdiction() {
        this.addJurisdictionFrom = {
          topJurisdiction_name: '',
          topJurisdiction_id: '',
          jurisdiction_name: '',
          jurisdiction_code: '',
          jurisdiction_level: '',
          commit: '',
          terminalJurisdiction: false,
          selectPeople: '',
          city: [],
          product: [],
        }
        this.modeldialog = true
        this.addJurisdictionFrom.topJurisdiction_name = this.nodeData.data.territory_name
        this.addJurisdictionFrom.topJurisdiction_id = this.nodeData.data.territory_id
        this.modeldialog = true
      },
      async getProductList1(id) {
        try {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.user_id = this.$store.getters.getUser.user_id
          data.territory_id = id
          data.checkedData = this.upDataJurisdictionFrom.product
          data.search = this.optionsQuery
          data.page = this.optionsPage
          await http.post('/wapi/Jur/getProductList_home2', data).then((res) => {
            // console.log(res)
            if (res.success === true) {
              if (res.data.length < 20) {
                this.finishOptions = true
              }
              if (data.page === 1) {
                this.productList1 = res.data
              } else {
                this.productList1 = this.productList1.concat(res.data)
              }
            }
          })
        } catch (e) { }
      },
      upDataJurisdiction() {
        if (this.isseach === true) {
          this.upDataJurisdictionFrom.product = []
          this.upDataJurisdictionFrom.product = this.search_data.productTerriTory.map((v) => v.product_id)
          this.getProductList1(this.search_data.territory_id)
          this.upDataJurisdictionFrom.topJurisdiction_id = ''
          this.upDataJurisdictionFrom.jurisdiction_id = this.search_data.territory_id
          this.upDataJurisdictionFrom.jurisdiction_name = this.search_data.territory_name
          this.upDataJurisdictionFrom.jurisdiction_code = this.search_data.territory_code
          this.upDataJurisdictionFrom.jurisdiction_level = this.search_data.territory_level_name
          this.upDataJurisdictionFrom.month = this.search_data.month
          this.upDataJurisdictionFrom.commit = this.search_data.comments
          this.upDataJurisdictionFrom.status = this.search_data.status
          this.upDataJurisdictionFrom.city = []
          if (this.search_data.cityList.length > 0) {
            for (let i = 0; i < this.search_data.cityList.length; i++) {
              let arr = []
              let p_id = this.search_data.cityList[i].province_id
              let c_id = this.search_data.cityList[i].city_id
              arr.push(p_id)
              arr.push(c_id)
              // console.log(arr)

              this.upDataJurisdictionFrom.city.push(arr)
            }
          }

          if (this.search_data.territory_type === 'CONTAINER') {
            this.upDataJurisdictionFrom.terminalJurisdiction = false
          } else {
            this.upDataJurisdictionFrom.terminalJurisdiction = true
          }
          this.upDataJurisdictionFrom.selectPeople = this.search_data.owner_id
          if (this.search_data.isThereData === 0) {
            //判断如果该辖区下有数据则无法设置成终端辖区
            this.disabledIsThree = false
          } else {
            this.disabledIsThree = true
          }
        } else {
          this.upDataJurisdictionFrom.product = []
          this.upDataJurisdictionFrom.product = this.nodeData.data.productTerriTory.map((v) => v.product_id)
          this.getProductList1(this.nodeData.parent.data.territory_id)
          this.upDataJurisdictionFrom.topJurisdiction_id = this.nodeData.parent.data.territory_id
          this.upDataJurisdictionFrom.jurisdiction_id = this.nodeData.data.territory_id
          this.upDataJurisdictionFrom.jurisdiction_name = this.nodeData.data.territory_name
          this.upDataJurisdictionFrom.jurisdiction_code = this.nodeData.data.territory_code
          this.upDataJurisdictionFrom.jurisdiction_level = this.nodeData.data.territory_level_name
          this.upDataJurisdictionFrom.month = this.nodeData.data.month
          this.upDataJurisdictionFrom.commit = this.nodeData.data.comments
          this.upDataJurisdictionFrom.status = this.nodeData.data.status
          this.upDataJurisdictionFrom.city = []
          if (this.nodeData.data.cityList.length > 0) {
            for (let i = 0; i < this.nodeData.data.cityList.length; i++) {
              let arr = []
              let p_id = this.nodeData.data.cityList[i].province_id
              let c_id = this.nodeData.data.cityList[i].city_id
              arr.push(p_id)
              arr.push(c_id)
              // console.log(arr)
              this.upDataJurisdictionFrom.city.push(arr)
            }
          }

          if (this.nodeData.data.territory_type === 'CONTAINER') {
            this.upDataJurisdictionFrom.terminalJurisdiction = false
          } else {
            this.upDataJurisdictionFrom.terminalJurisdiction = this.terminal
          }
          this.upDataJurisdictionFrom.selectPeople = this.nodeData.data.owner_id
          if (this.nodeData.data.isThereData === 0) {
            //判断如果该辖区下有数据则无法设置成终端辖区
            this.disabledIsThree = false
          } else {
            this.disabledIsThree = true
          }
        }
        debugger
        this.upDatamodeldialog = true
      },
      inputSaveJurisdiction() {
        this.$refs['addJurisdictionFrom'].validate((valid) => {
          if (valid) {
            this.saveJurisdiction()
          } else {
            // Message.error('保存失败')
            return false
          }
        })
      },
      closeAddDialog() {
        this.modeldialog = false
        this.$refs['addJurisdictionFrom'].resetFields()
      },
      async saveJurisdiction() {
        let data = this.addJurisdictionFrom
        if (this.addJurisdictionFrom.terminalJurisdiction == true) {
          data.jurisdiction_level = null
        }
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.month = moment(this.valueDate).format('YYYYMM')
        //
        // if (data.jurisdiction_name == '') {
        //     this.$message({
        //         type: 'error',
        //         message: '请填写辖区名称'
        //     })
        //     return false
        // }
        //
        // if (data.jurisdiction_code == '') {
        //     this.$message({
        //         type: 'error',
        //         message: '请填写辖区编码'
        //     })
        //     return false
        // }

        try {
          await http.post('/wapi/JurActive/saveJurisdiction', data).then((res) => {
            if (res.success === true) {
              // if (data.topJurisdiction_id) {
              //   this.refreshNodeBy(data.topJurisdiction_id);
              // } else {
              this.init(data.topJurisdiction_id)
              // }
              for (let key in this.addJurisdictionFrom) {
                this.addJurisdictionFrom[key] = ''
              }
              this.addJurisdictionFrom.terminalJurisdiction = false
              this.addJurisdictionFrom.city = []
            }
          })
        } catch (e) { }
        this.modeldialog = false
      },
      inputUpdata_Jurisdiction() {
        this.$refs['upDataJurisdictionFrom'].validate((valid) => {
          if (valid) {
            this.updata_Jurisdiction()
          } else {
            // Message.error('保存失败')
            return false
          }
        })
      },
      disable1() {
        if (this.upDataJurisdictionFrom.jurisdiction_name == '总部') {
          this.upDataJurisdictionFrom.terminalJurisdiction = true
        } else {
          this.upDataJurisdictionFrom.terminalJurisdiction = false
        }
      },
      closeUpdateDialog() {
        this.upDatamodeldialog = false
        this.$refs['upDataJurisdictionFrom'].resetFields()
      },
      async updata_Jurisdiction() {
        let data = this.upDataJurisdictionFrom
        if (this.upDataJurisdictionFrom.terminalJurisdiction == true) {
          data.jurisdiction_level = null
        }
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.terminalJurisdiction = this.terminal
        // if (data.jurisdiction_name == '') {
        //     this.$message({
        //         type: 'error',
        //         message: '请填写辖区名称'
        //     })
        //     return false
        // }
        // if (data.jurisdiction_code == '') {
        //     this.$message({
        //         type: 'error',
        //         message: '请填写辖区编码'
        //     })
        //     return false
        // }
        try {
          await http.post('/wapi/JurActive/updataJurisdiction', data).then((res) => {
            if (res.success === true) {
              // if (data.topJurisdiction_id) {
              //   this.refreshNodeBy(data.topJurisdiction_id);
              // } else {
              this.init(data.jurisdiction_id)
              // }

              this.$message({
                type: 'success',
                message: '更新成功',
              })
              this.index = new Date()

              // if (this.$route.fullPath === "/territoryActive/insActive") {
              //   this.$router.push({ path: "insActiveTow" });
              // } else if (this.$route.fullPath === "/territoryActive/insActiveTow") {
              this.$router.push({ path: 'insActive', query: { d: (this.upKey = new Date().getTime()) } })
              // }
            }
          })
          this.upDatamodeldialog = false
        } catch (e) { }
      },
      async getJurisdictionLevel() {
        try {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          await http.post('/wapi/JurActive/getJurisdictionLevel', data).then((res) => {
            if (res.success === true) {
              this.jurisdictionLevel = res.data
            }
          })
        } catch (e) { }
      },
    },
    created() {
      this.init()
      this.getJurisdictionUser()
      this.getJurisdictionLevel()
      this.getCity()
    },
    mounted() {
      if (this.$route.fullPath.indexOf('Active') !== -1) {
        this.styleA2 = true
        this.styleA = false
      }
      this.getProductList()
    },
    updated() {
      //console.log(this.$store.getters.getDataInfo,111)
    },
    beforeDestroy() {
      let obj = this.$store.getters.getDataInfo
      for (let key in obj) {
        obj[key] = ''
      }
      this.$store.commit('setDataInfo', obj)
    },
    computed: {
      listenStore() {
        return this.$store.getters.getDataInfo
      },
      //刷新页面树形数据
      changeTree() {
        let index = ''
        bus.$on('changeList', (e) => {
          this.index = e
        })
        return this.index
      },
      changeTreeRemove() {
        let index = ''
        bus.$on('changeTreeList', (e) => {
          this.indexRemove = e
        })
        return this.indexRemove
      },
    },
    watch: {
      valueDate(newValue, oldValue) {
        let obj = this.$store.getters.getDataInfo
        for (let key in obj) {
          obj[key] = ''
        }
        this.$store.commit('setDataInfo', obj)
        this.territory_name = ''
        this.territory_region = ''
        this.territory_code = ''
        this.owner_name = ''
        this.owner_title = ''
        this.salList = '0'
        // if (this.$route.fullPath === "/territoryActive/indexActive") {
        //   this.$router.push({ path: "indexActiveTow" });
        // } else {
        this.$router.push({ path: 'indexActive', query: { d: (this.upKey = new Date().getTime()) } })
        // }
        this.init()
        // let nowDate = moment().format('YYYY-MM')
        // let nextDate = moment().subtract(-1,'months').format('YYYY-MM')
        // if (newValue === nowDate || newValue ===nextDate) {
        //     this.save_onoff = true
        // }else {
        //     this.save_onoff = false
        // }
        let nowDate = moment().format('YYYY-MM')
        if (newValue < nowDate) {
          this.save_onoff = false
        } else {
          this.save_onoff = true
        }
      },
      changeTree: function (val, oldval) {
        // console.log(12)

        this.refreshNodeBy(this.parentNodeKey)
        this.loading = true
        let store = this.$refs.menusTreeAc.store
        let that = this

        setTimeout((e) => {
          // const node = store.getNode(this.sonNodeKey);
          for (let i in store.nodesMap) {
            if (that.sonNodeKey == i) {
              let getDataInfo = store.nodesMap[i].data
              let obj = this.$store.getters.getDataInfo
              for (let item in getDataInfo) {
                obj[item] = getDataInfo[item]
              }
              // console.log(obj)
              this.$store.commit('setDataInfo', getDataInfo)
              let data = this.$store.getters.getDataInfo
              this.territory_name = data.territory_name
              this.territory_level_name = data.territory_level_name
              // console.log(this.territory_level_name)
              if (data.territory_type === 'CONTAINER') {
                this.territory_region = '地区'
              } else {
                this.territory_region = '终端'
              }
              this.territory_code = data.territory_code
              this.owner_name = data.owner_name
              this.owner_title = data.title
              this.salList = data.salseList.length

              // if (this.$route.fullPath === '/territoryActive/indexActive') {
              //     this.$router.push({path:'indexActiveTow'})
              // } else if (this.$route.fullPath === '/territoryActive/indexActiveTow') {
              //     this.$router.push({path:'indexActive'})
              // } else if (this.$route.fullPath === '/territoryActive/institutionsActive') {
              //     this.$router.push({path:'institutionsTowActive'})
              // } else if (this.$route.fullPath === '/territoryActive/institutionsTowActive') {
              //     this.$router.push({path:'institutionsActive'})
              // }
              this.loading = false
            }
          }
        }, 500)
      },
      changeTreeRemove: function (val, oldval) {
        this.refreshNodeBy(this.parentNodeKey)
      },
    },
  }
</script>

<style lang="scss" module>
  .container {
    background: white;
    height: 100%;
    overflow: auto;

    .left {
      font-size: 18px;
      font-weight: bold;
      color: #000000;

      .search {
        width: 360px;
      }

      .type {
        em {
          color: #d98f2f;
          font-size: 14px;
          font-weight: bold;
        }
      }

      .first {
        color: #555555;
        font-size: 20px;
      }

      .font {
        margin-left: 20px;
        font-size: 14px;
        color: #555555;
      }
    }

    .right {
      margin-top: -20px;
      width: 100%;
      height: 100%;

      .header {
        width: 100%;
        border-bottom: 2px dotted #e7eaec;
        padding-bottom: 14px;
      }

      .body {
        overflow: auto;
        height: calc(100% - 62px);
      }
    }

    .noData {}
  }
</style>
<style>
  .el-container {
    padding: 20px;
    background: white;
    height: 100%;
  }

  #jurisdictionActive {
    background: white;
  }

  #jurisdictionActive .el-main {
    background: white;
  }

  /*限制文字长度*/
  #jurisdictionActive #treeDiv .el-tree-node__content span {
    /* max-width: 240px;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap; */
  }

  #jurisdictionActive #treeDiv .filter-tree .el-tree-node__expand-icon {
    display: none;
    margin-left: 0;
    font-size: 16px;
  }

  #jurisdictionActive #treeDiv .el-tree-node__label {
    font-size: 16px;
  }

  #jurisdictionActive #treeDiv .el-tree-node {
    white-space: inherit;
  }

  #jurisdictionActive #treeDiv .el-tree-node .el-tree-node__content {
    min-height: 40px;
    height: auto !important;
  }

  #jurisdictionActive #treeDiv .el-tree-node__content .el-tree-node__expand-icon {
    flex-shrink: 0;
  }

  #jurisdictionActive #treeDiv .el-tree-node__label:before {
    content: '';
    display: inline-block;
    /*background: url("../../assets/images/jurisdiction2.png") no-repeat;*/
    /*background-size: 16px;*/
    width: 16px;
    height: 16px;
    margin: 0 10px;
  }

  #jurisdictionActive #treeDiv .el-tree-node__content {
    /*display: flex;*/
    /*justify-content: space-between;*/
    height: 40px;
  }

  #jurisdictionActive #treeDiv .filter-tree .el-tree-node__content:before {
    content: '';
    display: inline-block;
    /*background: url("../../assets/images/role.png") no-repeat;*/
    /*background-size: 16px;*/
    width: 16px;
    height: 16px;
    margin: 20px;
  }

  #jurisdictionActive #inputData {
    width: 240px;
    border-radius: 0;
    text-align: center;
    color: #ff9901;
  }

  #jurisdictionActive .el-input__inner::-webkit-input-placeholder {
    text-align: center;
  }

  #jurisdictionActive .el-dialog__header {
    border-bottom: 2px dashed #dcdfe6;
    padding: 20px 0 20px 0;
    margin: 20px 20px 10px;
  }

  #jurisdictionActive .el-dialog__close {
    display: none;
  }

  #jurisdictionActive .el-dialog__body {
    padding-right: 100px;
  }

  #jurisdictionActive #inputSeach {
    padding: 0px;
    border-radius: 3px;
    background: #ededed;
    height: 30px;
    text-align: center;
  }

  #jurisdictionActive #el-rowInput .el-input {
    width: 348px;
    padding: 5px;
    border: 1px solid #dedede;
  }

  #jurisdictionActive #formSave label {
    font-size: 16px;
    font-weight: bold;
    color: black;
  }

  #jurisdictionActive #elColImport .el-input {
    height: 30px;
  }

  #jurisdictionActive #elColImport #elInputImport {
    height: 30px !important;
  }

  #jurisdictionActive #effect {
    color: #303133;
    font-size: 14px;
    display: inline-block;
    padding: 10px 20px;
    border: 1px solid #dcdfe6;
    text-decoration: none;
    border-radius: 4px;
  }

  #jurisdictionActive #effect:hover {
    color: #1989fa;
    background: #e6f1fc;
    border: 1px solid #a3d0fd;
    transition: 0.2s;
  }

  #jurisdictionActive #effect2 {
    color: #303133;
    font-size: 14px;
    display: inline-block;
    padding: 10px 20px;
    border: 1px solid #dcdfe6;
    text-decoration: none;
    border-radius: 4px;
  }

  #jurisdictionActive #effect2:hover {
    color: #1989fa;
    background: #e6f1fc;
    border: 1px solid #a3d0fd;
    transition: 0.2s;
  }

  #jurisdictionActive #effect.styleA {
    color: #1989fa;
    background: #e6f1fc;
    border: 1px solid #a3d0fd;
    transition: 0.2s;
  }

  #jurisdictionActive #effect2.styleA {
    color: #1989fa;
    background: #e6f1fc;
    border: 1px solid #a3d0fd;
    transition: 0.2s;
  }

  #regionP {
    margin-left: 5px;
    padding: 5px 14px;
    display: inline-block;
    font-size: 12px;
    border: 1px solid #db4dd7;
    color: #db4dd7;
    border-radius: 4px;
  }

  .el-button--primary:focus {
    border-color: #c6e2ff;
  }

  #add_jurisdictionActive .el-cascader__tags .el-tag {
    background: #ff9901 !important;
    color: white;
  }

  #add_jurisdictionActive .el-cascader__tags .el-tag .el-icon-close {
    background: #ff9901 !important;
  }

  #add_jurisdictionActive .el-select {
    width: 100%;
  }

  #add_jurisdictionActive .el-select .el-tag {
    background: #ff9901 !important;
    border: none;
    color: white;
  }

  #add_jurisdictionActive .el-select .el-tag .el-icon-close {
    background: #ff9901 !important;
    color: white;
  }

  #update_jurisdictionActive .el-cascader__tags .el-tag {
    background: #ff9901 !important;
    color: white;
  }

  #update_jurisdictionActive .el-cascader__tags .el-tag .el-icon-close {
    background: #ff9901 !important;
  }

  #update_jurisdictionActive .el-select {
    width: 100%;
  }

  #update_jurisdictionActive .el-select .el-tag {
    background: #ff9901 !important;
    border: none;
    color: white;
  }

  #update_jurisdictionActive .el-select .el-tag .el-icon-close {
    background: #ff9901 !important;
    color: white;
  }

  #add_jurisdictionActive .el-form-item__label {
    font-size: 16px;
    color: black;
  }

  #update_jurisdictionActive .el-form-item__label {
    font-size: 16px;
    color: black;
  }

  #add_jurisdictionActive .el-dialog__header {
    padding: 10px 20px 10px;
  }

  #update_jurisdictionActive .el-dialog__header {
    padding: 10px 20px 10px;
  }

  #add_jurisdictionActive .el-dialog__body {
    padding: 10px 20px;
  }

  #update_jurisdictionActive .el-dialog__body {
    padding: 20px 20px;
  }

  #add_jurisdictionActive .jurisdiction_star label:after {
    content: '*';
    color: #f56c6c;
    margin-left: 4px;
  }

  #update_jurisdictionActive .jurisdiction_star label:after {
    content: '*';
    color: #f56c6c;
    margin-left: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/jurisdiction/homeactive.vue